import { render, staticRenderFns } from "./AddSurveyQuestion.vue?vue&type=template&id=559122ac&scoped=true&"
import script from "./AddSurveyQuestion.vue?vue&type=script&lang=js&"
export * from "./AddSurveyQuestion.vue?vue&type=script&lang=js&"
import style0 from "./AddSurveyQuestion.vue?vue&type=style&index=0&id=559122ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559122ac",
  null
  
)

export default component.exports